import cx from 'classnames';
import "./ModalBody.css";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ModalBody(_ref) {
  let {
    children,
    className,
    tag: Tag = 'div'
  } = _ref;
  return /*#__PURE__*/_jsx(Tag, {
    className: cx('ModalBody', className),
    "data-sentry-element": "Tag",
    "data-sentry-component": "ModalBody",
    "data-sentry-source-file": "ModalBody.tsx",
    children: children
  });
}